export type Inspection = {
    id: string;
    vesselName: string | null;
    vesselImo: string | null;
    inspectionTypeId: number | null;
    inspectionType: string | null;
    inspectionNumber: string | null;
    inspectionDateFrom: string | null;
    inspectionDateTo: string | null;
    inspectionReport: InspectionElement[] | null;
    orderedDate: string | null
    issuedAt: string | null;
    reportDate: string | null;
    status: string | null;
    port: string | null;
    country: string | null;
    recommendedPrice: string | null;
    quoteLink: string | null;
    earlyRelease: boolean | null;
    vesselType: string | null;
    overallScore: number | null;
    managementScore: number | null;
    conditionScore: number | null;
    totalPrice: number | null;
    enableLowPriorityDefects: boolean | null;
    grades: Grade[] | null;
    [key: string]: unknown;
}

export enum InspectionStatus {
    NEW = "NEW",
    BIDDING = "BIDDING",
    UPCOMING = "UPCOMING",
    CONFIRMED = "CONFIRMED",
    INSPECTION_COMPLETED = "INSPECTION_COMPLETED",
    FULL_REPORT = "FULL_REPORT",
    CANCELLED = "CANCELLED",
    COMMENCED = "COMMENCED",
}

export type InspectionElement = {
    AvailableForCustomer: boolean;
    ElementType: number;
    Id: number;
    InspectionId: string;
    Released: boolean;
    Name: string;
    SortOrder: number;
}

export type Grade = {
    id: number;
    inspectionId: string;
    vesselGradeId: number;
    type: number;
    name: string;
    weight: number;
    score: number;
    point: number;
    adjustedPoint?: number;
}

export type AdjustedGrade = {
    vesselGradeId: number;
    gradeValue: number;
}

export type AdjustedGradeDto = {
    adjustedGrades: AdjustedGrade[];
    calculatedGrades: CalculateGrades;
}

export type CalculateGrades = {
    managementGrade: ManagementGrade;
    conditionGrade: ConditionGrade;
    overallGrade: number;
}

export type ConditionGrade = {
    totalConditionGrade: number;
    maxConditionGrade: number;
    computedConditionGrade: number;
}

export type ManagementGrade = {
    totalManagementGrade: number;
    maxManagementGrade: number;
    computedManagementGrade: number;
}

export type AiSummary = {
    sectionId: string;
    augmentedText: string;
    originalText: string;
}